// extracted by mini-css-extract-plugin
export var avatar = "_lu-3";
export var avatarContainer = "_lu-2";
export var avatarSpacer = "_lu-5";
export var avatarSpacerContainer = "_lu-4";
export var avatarStackContainer = "_lu-1";
export var bubble = "_lu-0";
export var remainderBubble = "_lu-6";